import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? "http://localhost:5002",
  withCredentials: true,
  // baseURL: "http://localhost:5002",
});

//  Request interceptor
api.interceptors.request.use(
  function (config) {
    const token = cookies.get("access_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    // ✅ Cookie-г илгээхийн тулд withCredentials тохируулна
    config.withCredentials = true;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// ✅ Response interceptor (refresh logic)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/api/auth/login")
    ) {
      originalRequest._retry = true;
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/auth/refresh`,
          {},
          { withCredentials: true }
        );

        // console.log("refresh req --->", res);
        const accessToken = res.data.access_token;
        cookies.set("access_token", accessToken);
        // console.log("token refresh running ---> ", accessToken);

        originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        // console.log("Retrying request with headers:", originalRequest.headers);

        return api(originalRequest);
      } catch (err) {
        cookies.remove("access_token");
        window.location.href = "/login";
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

const POST = "POST",
  GET = "GET",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
  URLENCODED = "urlencoded",
  FORMDATA = "formdata",
  JSONDATA = "json";

export default function apiRequest(
  method,
  url,
  data,
  contenttype,
  onUploadProgress
) {
  let ct;
  if (contenttype === URLENCODED) ct = "application/x-www-form-urlencoded";
  if (contenttype === FORMDATA) ct = "multipart/form-data";
  if (contenttype === JSONDATA) ct = "application/json";

  const config = {
    headers: { ...(ct && { "content-type": ct }) },
    withCredentials: true, // ✅ Cookie-г илгээхийн тулд withCredentials тохируулна
    ...(onUploadProgress && { onUploadProgress }),
  };

  if (method === GET) {
    return api
      .get(url, {
        ...config,
        ...(data && { params: data }),
      })
      .then((res) => res)
      .catch((err) => err.response);
  }

  if (method === POST) {
    return api
      .post(url, data, config)
      .then((res) => res)
      .catch((err) => err.response);
  }

  if (method === PUT) {
    return api
      .put(url, data, config)
      .then((res) => res)
      .catch((err) => err.response);
  }

  if (method === PATCH) {
    return api
      .patch(url, data, config)
      .then((res) => res)
      .catch((err) => err.response);
  }

  if (method === DELETE) {
    return api
      .delete(url, {
        ...config,
        data,
      })
      .then((res) => res)
      .catch((err) => err.response);
  }
}
